import { render } from "./EventTicketBlock.vue?vue&type=template&id=67d5912b&scoped=true"
import script from "./EventTicketBlock.vue?vue&type=script&lang=js"
export * from "./EventTicketBlock.vue?vue&type=script&lang=js"

import "./EventTicketBlock.vue?vue&type=style&index=0&id=67d5912b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d5912b"]])

export default __exports__